import { createAsyncThunk } from "@reduxjs/toolkit";
import { notify } from "../../../utils/shared";
import { getAllProducts } from "../../../services/plan.service";

export const getProducts = createAsyncThunk(
  "getProducts",
  async (values:any, { rejectWithValue, dispatch }) => {
    try {
      const response = await getAllProducts();
      return response;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

